export default __webpack_public_path__ + "static/media/andouilles2.6883cd6e.jpeg";